import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-invoice-rule-config',
  standalone: false,
  templateUrl: './invoice-rule-config.component.html',
  styleUrls: ['./invoice-rule-config.component.scss']
})
export class InvoiceRuleConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor(private apiHandler: ApiService) { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'invoice-rule',
        approxamateRowCount: 1000,
        anyParams: true

      },
      colConfig: [
        { field: 'invoiceruleid', header: 'Invoice Rule ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true  },
        { field: 'rulecode', header: 'Rule Code', type: ColumnType.String },
        { field: 'rulename', header: 'Rule Name', type: ColumnType.String },
        { field: 'rule', header: 'Rule', type: ColumnType.String },
        { field: 'priority', header: 'Priority', type: ColumnType.String }
      ],
      addFormConfig: {
        header: 'Add Invoice Rules'
      },
      isConfigurable: true
    };
  }
}
